import PropTypes from "prop-types"
import React, { useEffect } from "react"

import { logoutUser } from "../../store/actions"

//redux
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import {
  Alert,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row
} from "reactstrap"
import logo from "../../assets/images/logo-sm.png"
import CarouselPage from '../../pages/AuthenticationInner/CarouselPage'
import {getAuthType, isAnyValueEmpty} from "../../components/Common/CommonLogic";
import {ToastWrapper} from "../../components/Common/CustomToast";



const Logout = props => {
  //localStorage.removeItem("isNetworkLogin");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logoutUser(props?.history))
  }, [dispatch, props.history])

  return (
      <React.Fragment>
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
          <Card className="shadow p-4" style={{ minWidth: '460px', maxWidth: '460px' }}>
            <CardBody>
              <div className="w-100 align-self-center">
                <div className="d-flex flex-column h-100">
                  <div className="mb-4 mb-md-5 text-center">
                    <Link to="index.html" className="d-block auth-logo">
                      <img src={logo} alt="" height="64" />
                    </Link>
                  </div>
                  <div className="auth-content my-auto">
                    <div className="text-center">
                      <div className="avatar-xl mx-auto">
                        <div className="avatar-title bg-light-subtle text-primary h1 rounded-circle">
                          <i className="bx bxs-user"></i>
                        </div>
                      </div>

                      <div className="mt-4 pt-2">
                        <h5>You are Logged Out</h5>
                        <p className="text-muted font-size-15">Thank you for using <span className="fw-semibold text-primary">Tarifftales</span></p>
                        <div className="mt-4">
                          {/* <button className="btn btn-primary w-100 waves-effect waves-light">Sign In</button> */}
                          <Link to={getAuthType() === '1' ? "/network/dashboard" : "/dashboard" }  onClick={() => {window.reload();}} className="btn btn-primary w-100 waves-effect waves-light">Sign In</Link>
                        </div>
                      </div>
                    </div>

                    <div className="mt-3 text-center">
                      <p className="text-muted mb-0">Don't have an account ? <Link to="/register" onClick={() => {window.reload();}}
                                                                                   className="text-primary fw-semibold"> Signup</Link> </p>
                    </div>
                  </div>
                  <div className="mt-4 mt-md-5 text-center">
                    <p className="mb-0">© 2022-2023 Tarifftales All rights reserved.</p>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <ToastWrapper />
      </React.Fragment>
  )
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default Logout
